import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "error-global_close d-flex a-i-center j-content-s-ar" }

import { toRefs } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'errorGlobalView',
  props: {
    error: { type: Boolean },
    changeError: { type: Function },
    changeError2: { type: Function }
  },
  setup(__props: any) {

const props = __props;


const data = toRefs(props)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "position-fixed z-index_10 direction-column a-i-center error-global j-content-center top-0 left-0 right-0 bottom-0 h-100-vh w-100 d-flex",
    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_unref(data).changeError.value()), ["self"]))
  }, [
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", {
        class: "btn btn-default",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(data).changeError.value()), ["stop"]))
      }, "OK"),
      (typeof _unref(data).changeError2.value === 'function')
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "btn btn-default",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(data).changeError2.value()), ["stop"]))
          }, "REJECT"))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})